import React from 'react';
import ReactDOM from 'react-dom';

import RouterTest from './components/navigation/test';

ReactDOM.render(<RouterTest />,document.getElementById('root'));
